/**
 * @desc 列表
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(params: API.bus.openApiConfig.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/openApiConfig/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
